import chart from 'assets/icons/chart.svg';
import React, {Component} from 'react';
import {Bar, BarChart, Cell, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import './profit-and-loss.style.scss';
import {get} from 'lodash';
import {nFormatter, ONE_BILLION} from '../../../../utils';

export default class ProfitAndLoss extends Component {
  render() {
    const data = [
      {
        name: 'NET INTEREST INCOME',
        value: 500,
        percent: 92,
      },
      {
        name: 'NET GAIN FROM SERVICE',
        value: 520,
        percent: 90,
      },
      {
        name: 'NET GAIN FROM FX',
        value: 180,
        percent: 80,
      },
      {
        name: 'NET GAIN FROM SECURTIES',
        value: 200,
        percent: 78,
      },
      {
        name: 'TOTAL OPERATING INCOME',
        value: 1400,
        percent: 89,
      },
      {
        name: 'OPERATING EXPENSE',
        value: 500,
        percent: 90,
      },
      {
        name: 'PROVISION',
        value: 180,
        percent: 91,
      },
      {
        name: 'PROFIT BEFORE TAX',
        value: 720,
        percent: 90,
      },
      {
        name: 'ECONOMIC PROFIT',
        value: get(this.props.data, 'bankwide.economic_profit', 0) / ONE_BILLION || 0,
        percent: 93,
      },
    ].map((item) => ({...item, remainingPercent: 100 - item.percent, total: 100}));
    console.log('🚀 ~ ProfitAndLoss ~ render ~ this.props.data:', this.props.data);

    const colors = [
      '#FDE39B',
      '#FDE39B',
      '#FDE39B',
      '#FDE39B',
      '#FBC83A',
      '#FBC83A',
      '#FBC83A',
      '#C89404',
      '#644A02',
    ];
    return (
      <div className='profit-and-loss-container'>
        <h1 className='title'>
          <img src={chart} alt='' style={{marginRight: 8}} />
          PROFIT AND LOSS
        </h1>
        <div className='chart-container'>
          <ResponsiveContainer width='30%' height={data.length * 35}>
            <BarChart layout='vertical' data={data}>
              <XAxis type='number' hide />
              <YAxis type='category' dataKey='percent' hide />
              <Bar dataKey='total'>
                <LabelList dataKey='name' content={renderCustomizedLabel} />
                <LabelList dataKey='value' content={renderCustomizedLabelValue} />

                {data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={colors[index % data.length]}
                    height={30}
                    radius={4}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>

          <ResponsiveContainer width='70%' height={data.length * 35}>
            <BarChart layout='vertical' data={data}>
              <XAxis type='number' hide />
              <YAxis type='category' dataKey='percent' hide />
              <Tooltip cursor={false} content={<CustomTooltip data={data} colors={colors} />} />
              <Bar dataKey='percent' stackId='a'>
                {data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={colors[index % colors.length]}
                    height={30}
                    radius={4}
                  />
                ))}
                <LabelList dataKey='percent' content={renderCustomizedLabelPercent} />
              </Bar>
              <Bar dataKey='remainingPercent' stackId='a'>
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill='#EBEBEB' height={30} radius={4} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
}
const renderCustomizedLabel = (props) => {
  const {x, y, height, value, index} = props;

  return (
    <g>
      <text
        x={x + 16}
        y={y + height / 2}
        fill={index >= 7 ? '#FFFFFF' : '#0B0B0A'}
        dominantBaseline='middle'
        fontSize={14}>
        {value}
      </text>
    </g>
  );
};

const renderCustomizedLabelValue = (props) => {
  const {x, y, width, height, value, index} = props;

  return (
    <g>
      <text
        x={x + width - 16}
        y={y + height / 2}
        fill={index >= 7 ? '#FFFFFF' : '#0B0B0A'}
        textAnchor='end'
        dominantBaseline='middle'
        fontSize={14}
        fontWeight={600}>
        {nFormatter(+value)}
      </text>
    </g>
  );
};

const renderCustomizedLabelPercent = (props) => {
  const {x, y, width, height, value, index} = props;

  return (
    <g>
      <text
        x={x + width / 2}
        y={y + height / 2}
        fill={index >= 7 ? '#FFFFFF' : '#0B0B0A'}
        textAnchor='middle'
        dominantBaseline='middle'
        fontSize={14}
        fontWeight={600}>
        {value}%
      </text>
    </g>
  );
};

const CustomTooltip = (props) => {
  const {active, payload, data, colors} = props;

  if (active && payload && payload.length) {
    const item = payload[0].payload;
    const index = data.findIndex((el) => el.name === item.name);

    return (
      <div className='custom-tooltip' style={{backgroundColor: colors[index % data.length]}}>
        <span className='name'>{item.name}</span>
        <span className='desc'>
          {nFormatter(item.value)}/{item.percent}%
        </span>
      </div>
    );
  }

  return null;
};



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/ProfitAndLoss/ProfitAndLoss.js